import KeenSlider from 'keen-slider';

function navigation(slider) {
    let wrapper, dots, arrowLeft, arrowRight, arrowContainer

    function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
    }

    function removeElement(elment) {
        elment.parentNode.removeChild(elment)
    }

    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    function createLink(className,link,linkText) {
        var anchor = document.createElement("a");
        var classNames = className.split(" ");
        classNames.forEach((name) => anchor.classList.add(name));
        anchor.href = link;
        anchor.innerText = linkText;
        return anchor
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft)
            removeElement(arrowRight)
            removeElement(arrowContainer)
            return
        }

        let arrowClass = slider.options.arrowClass;
        let link = jQuery(slider.container).parent().parent().attr('data-link');

        arrowContainer = createDiv("arrow-container "+arrowClass);
        wrapper.prepend(arrowContainer);

        arrowLeft = createDiv("arrow arrow--left")
        arrowLeft.addEventListener("click", () => slider.prev())
        arrowRight = createDiv("arrow arrow--right")
        arrowRight.addEventListener("click", () => slider.next())

        if (link !== undefined && link !== ''){
            arrowContainer.appendChild(createLink("btn btn-outline-primary",link,'More'));
        }

        arrowContainer.appendChild(arrowLeft)
        arrowContainer.appendChild(arrowRight)
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
                parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
        }
        wrapper = createDiv("navigation-wrapper")
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
    }

    function dotMarkup(remove) {

        if (slider.options.dots === false) return;

        if (remove) {
            removeElement(dots)
            return
        }
        dots = createDiv("dots")
        slider.track.details.slides.forEach((_e, idx) => {
            if ((idx - slider.options.slides.perView) < -1 ) return;
            var dot = createDiv("dot")
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dots.appendChild(dot)
        })
        wrapper.appendChild(dots)
    }

    function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0 ? arrowLeft.classList.add("arrow--disabled") : arrowLeft.classList.remove("arrow--disabled");

        let perview = slider.options.slides.perView ?? 1;

        if (slider.options.loop === true) return;

        if (perview === 1)
            slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add("arrow--disabled")
                : arrowRight.classList.remove("arrow--disabled");
        else {
            if(
                ((slide+perview) === slider.track.details.slides.length) || (slider.track.details.slides.length <= perview)
            )
                arrowRight.classList.add("arrow--disabled");
            else
                arrowRight.classList.remove("arrow--disabled");
        }

        //console.log(perview, slider.track.details.slides.length,slide,slider);

        if (slider.options.dots !== false) {
            Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide
                    ? dot.classList.add("dot--active")
                    : dot.classList.remove("dot--active")
            })
        }
    }

    slider.on("created", () => {
        markup()
        updateClasses()
    })
    slider.on("optionsChanged", () => {
        console.log(2)
        markup(true)
        markup()
        updateClasses()
    })
    slider.on("slideChanged", () => {
        updateClasses()
    })
    slider.on("destroyed", () => {
        markup(true)
    })
}

document.addEventListener("DOMContentLoaded", function() {

    if (document.getElementById('home-featured')) {
        let slider = new KeenSlider("#home-featured", {
            origin: "center",
            breakpoints: {
                "(min-width: 400px)": {
                    slides: {perView: 1, spacing: 5},
                },
                "(min-width: 991px)": {
                    slides: {perView: 2, spacing: 5},
                },
                "(min-width: 1200px)": {
                    slides: {perView: 3, spacing: 5},
                },
            },
            slides: {perView: 1,},
            loop: true,
            arrowClass : 'normal',
        }, [navigation]);
    }

    let product_sliders = jQuery('.noor-slider.products');
    generateProductSliders(product_sliders);
});

function generateProductSliders(product_sliders){

    if (product_sliders.length) {
        for(let i=0; i < product_sliders.length; i++){

            let mobile_width = jQuery(product_sliders[i]).attr('data-width');
            let options  = {
                origin: "center",
                breakpoints: {
                    "(min-width: 300px)": {
                        slides: {perView: 2, spacing: 10},
                    },
                    "(min-width: 991px)": {
                        slides: {perView: 3, spacing: 15},
                    },
                    "(min-width: 1200px)": {
                        slides: {perView: 4, spacing: 15},
                    },
                },
                slides: {perView: 1,},
                loop: false,
                dots: false,
                arrowClass : 'side-arrow',
            };

            if (mobile_width !== undefined){
                delete options["breakpoints"]["(min-width: 300px)"];
                let temp = "(min-width: "+mobile_width+")";
                options["breakpoints"] = {};
                options["breakpoints"][temp] = { slides: {perView: 2, spacing: 10} } ;
                options["breakpoints"]["(min-width: 991px)"] = { slides: {perView: 3, spacing: 15} } ;
                options["breakpoints"]["(min-width: 1200px)"] = { slides: {perView: 4, spacing: 15} } ;
            }

            new KeenSlider(product_sliders[i], options, [navigation]);
        }
    }
}

window.generateProductSliders = generateProductSliders;